import type { ValueOf } from '@weft/utils';

export const TOAST_ICON_COLORS = Object.freeze({
  ERROR:  '#C62828',
  SUCCESS: '#01A452',
});

export type ToastIconColor = ValueOf<typeof TOAST_ICON_COLORS>;